<ng-container *ngIf="invoice">
    <ng-container *ngIf="disableLink; else withLink">
        <span [attr.data-test]="dataTest">
            <ng-container *ngIf="viewData; else noIdent">
                {{viewData}}
            </ng-container>
            <ng-template #noIdent>
                <abbr matTooltip="Beleg kann nicht identifiziert werden!">
                    <em>Kein Name</em>
                </abbr>
            </ng-template>
        </span>
    </ng-container>
    <ng-template #withLink>
        <a (click)="click($event)"
           [attr.data-test]="dataTest"
           [bcmRouterLink]="['accounting', 'invoices', 'view', invoice.id]">
            <ng-container *ngIf="viewData; else noIdent">
                {{viewData}}
            </ng-container>
            <ng-template #noIdent>
                <abbr matTooltip="Beleg kann nicht identifiziert werden!">
                    <em>Kein Name</em>
                </abbr>
            </ng-template>
        </a>
    </ng-template>
</ng-container>
